/* eslint-disable */
import React from "react";
import { usePermissionsContext } from "./permissionProvider";
import { checkPermission } from "./checkPermission";

export const useHasPermission = (permissionPath: string) => {
  const { permissions, isLoading } = usePermissionsContext();
  const has = checkPermission(permissions, permissionPath);
  return { has, isLoading };
};

export const RequirePermission: React.FC<{
  permission: string;
  fallback?: React.ReactNode;
  hideIfNo?: boolean;
  children: React.ReactElement;
}> = ({ permission, fallback = null, hideIfNo = false, children }) => {
  const { has, isLoading } = useHasPermission(permission);

  if (isLoading) {
    try {
      return React.cloneElement(children, { disabled: true });
    } catch {
      return <>{children}</>;
    }
  }

  if (has) return children;
  if (hideIfNo) return null;
  return <>{fallback ?? React.cloneElement(children, { disabled: true })}</>;
};
